import { render, staticRenderFns } from "./RejectRequest.vue?vue&type=template&id=0476af2e"
import script from "./RejectRequest.vue?vue&type=script&lang=js"
export * from "./RejectRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports